import { ArrowRight } from "lucide-react";
import { Button } from "./ui/Button";
import { openWhatsApp } from "../utils/whatsapp";
import LibraryImage from "../assets/study-abroad.jpg";
import GraduationImage from "../assets/education.jpg";

export default function DetailsSection() {
  return (
    <section
      className="w-full min-h-screen flex bg-white items-center justify-center px-6 py-16 md:px-12 lg:px-20"
      content-visibility="auto"
      contain-intrinsic-size="800px"
    >
      <div className="max-w-7xl w-full grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Images Section */}
        <div className="relative h-[500px] lg:h-[600px]">
          {/* Main Image - Full size background */}
          <div className="absolute inset-0">
            <img
              src={GraduationImage}
              alt="Main destination"
              className="rounded-lg w-full h-full object-cover shadow-lg"
              loading="lazy"
              width="600"
              height="500"
            />
          </div>

          {/* Secondary Image - Small overlap at bottom right */}
          <div className="absolute bottom-0 right-0 w-[65%] h-[50%] md:translate-x-8 md:translate-y-8 lg:translate-x-12 lg:translate-y-12">
            <img
              src={LibraryImage}
              alt="Secondary destination"
              className="rounded-lg w-full h-full object-cover shadow-2xl border-4 border-white"
              loading="lazy"
              width="400"
              height="300"
            />
          </div>
        </div>

        {/* Content Section */}
        <div className="flex flex-col justify-center items-center lg:items-start text-center lg:text-left space-y-6">
          <h1 className="font-poppins text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight leading-tight text-gray-900 antialiased">
            BEGINPACK LTD
            <br />
            <span className="block">Travel Smart</span>
            <span className="block">Study Wise. Migrate Right.</span>
          </h1>

          <div className="space-y-4 text-gray-600 font-jakarta">
            <p className="text-base md:text-lg tracking-tight leading-tight antialiased ">
              Your trusted partner for professional study abroad guidance,
              migration support, and affordable flight ticket bookings. With
              over 7 years of experience, we have successfully guided hundreds
              of students, skilled professionals, and families in achieving
              their international goals.
            </p>

            <p className="text-base md:text-lg tracking-tight antialiased leading-relaxed">
              Our dedicated team provides expert advice on course and university
              selection, scholarship applications, visa filing, migration
              pathways, and pre-departure planning. We also make travel
              effortless with reliable and cost-effective flight bookings. At
              BeginPack, we ensure every step of your journey is smooth,
              well-prepared, and stress-free, empowering you to pursue your
              global dreams with confidence
            </p>
          </div>

          <div className="pt-4">
            <Button
              size="lg"
              className="rounded-full px-8 py-6 text-base font-poppins tracking-tight leading-tight antialiased font-medium"
              rightIcon={<ArrowRight className="w-5 h-5" />}
              onClick={() =>
                openWhatsApp(
                  "Hello! I would like to get in touch with BeginPack Ltd.\n\nName:\nEmail:\nPhone:\nService of interest:",
                )
              }
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
